module.exports = __webpack_public_path__ + "img/d200809-1.48df3905.jpg";